import { render } from "./DashboardEventsSinglePage.vue?vue&type=template&id=661570c4"
import script from "./DashboardEventsSinglePage.vue?vue&type=script&lang=js"
export * from "./DashboardEventsSinglePage.vue?vue&type=script&lang=js"

import "./DashboardEventsSinglePage.vue?vue&type=style&index=0&id=661570c4&lang=scss"

import exportComponent from "C:\\Users\\oi\\Desktop\\TFC\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QList from 'quasar/src/components/item/QList.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QDrawer,QList,QBtn,QSkeleton,QPageContainer,QPage,QIcon,QSelect,QCard,QTab});
